// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin forms own native submission.
import { useEventListener } from "@vueuse/core";
import { isPresent, toBoolean } from "#ce/utils/props";

const initializedForms = new WeakMap();

/** Normalizes reselected, enabled optional single `sp-select` controls to an offered blank or their previous choice. Resolves to its disposer. */
export async function initializeSingleSelectSubmission(form) {
  if (initializedForms.has(form)) {
    return initializedForms.get(form);
  }

  const previousValues = new WeakMap();
  const restoredSelects = new WeakSet();
  const stopInteraction = useEventListener(form, ["pointerdown", "keydown"], rememberSelectionBeforeInteraction, {
    capture: true,
  });
  const stopSelectionEvents = useEventListener(form, ["input", "change"], normalizeClearedSelect, { capture: true });

  function rememberSelectionBeforeInteraction(event) {
    const select = event.target;

    if (isOptionalEnabledSingleSelect(select)) {
      previousValues.set(select, select.value);
    }
  }

  function normalizeClearedSelect(event) {
    const select = event.target;

    if (event.type === "change" && restoredSelects.delete(select)) {
      event.stopImmediatePropagation();

      return;
    }

    if (!isOptionalEnabledSingleSelect(select) || select.value != null) {
      return;
    }

    const offersBlank =
      isPresent(select.prompt) ||
      select.items?.some((item) => item.value === "" && !toBoolean(item.disabled) && !toBoolean(item.props?.disabled));

    if (offersBlank) {
      select.value = "";

      return;
    }

    const previousValue = previousValues.get(select);

    if (previousValue != null && previousValue !== "") {
      select.value = previousValue;
      event.stopImmediatePropagation();

      if (event.type === "input") {
        restoredSelects.add(select);
      }
    }
  }

  function disposeSingleSelectSubmission() {
    stopInteraction();
    stopSelectionEvents();
    initializedForms.delete(form);
  }

  initializedForms.set(form, disposeSingleSelectSubmission);

  return disposeSingleSelectSubmission;
}

function isOptionalEnabledSingleSelect(select) {
  return (
    select.matches?.("sp-select") &&
    !isPresent(select.multiple) &&
    !isPresent(select.required) &&
    !select.matches(":disabled")
  );
}
